import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  columns: null,
  data: null,
  saveLeadData: null,
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    saveColumn(state, action) {
        state.isLoading = false;
        state.columns = action.payload;
    },

    saveData(state, action) {
        state.isLoading = false;
        state.data = action.payload;
    },

    saveLeadData(state, action) {
      state.isLoading = false;
      state.saveLeadData = action.payload;
    },
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow } = slice.actions;

// ----------------------------------------------------------------------

export function saveCSVData(columns, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.saveColumn(columns));
    dispatch(slice.actions.saveData(data));
  };
}

export function saveLeadData(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/savelead', {data: data});
      dispatch(slice.actions.saveLeadData(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function formatSaveLeadData() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.saveLeadData(null));
  };
}
